import React from 'react'
import PropTypes from 'prop-types'
import { Button } from '@resurs/midas-react'
import NumberFormat from 'react-number-format'
import { getText } from '../../internal/TextLabels'

const CreditInfo = ({ onSendMail, cost, limit }) => {
  const tdStyle = { border: 'none', padding: '0.2rem 0' }
  return (
    <React.Fragment>
      {cost && cost.monthlyCost !== undefined && (
        <div
          style={{
            borderLeft: '2px solid lightgrey',
            color: 'grey',
            padding: '0.2rem 1rem',
          }}
        >
          <table style={{ width: '100%' }}>
            <thead>
              <tr style={{ border: 'none' }}>
                <th style={{ ...tdStyle, color: 'black' }}>
                  {getText('payApply.priceSignageCost.calculation')}
                </th>
                <th style={{ ...tdStyle, textAlign: 'right' }}>
                  <Button
                    onClick={() => {
                      onSendMail()
                    }}
                  >
                    {getText('payApply.priceSignageCost.sendMail')}
                  </Button>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr key="limit">
                <td style={tdStyle}>
                  {getText('payApply.priceSignageCost.limit')}
                </td>
                <td style={{ ...tdStyle, textAlign: 'right' }}>
                  <NumberFormat
                    value={limit}
                    displayType="text"
                    thousandSeparator=" "
                    renderText={val => getText('default.currency', val)}
                  />
                </td>
              </tr>
              <tr key="monthlyCost">
                <td style={tdStyle}>
                  {getText('payApply.priceSignageCost.monthlyCost')}
                </td>
                <td style={{ ...tdStyle, textAlign: 'right' }}>
                  <NumberFormat
                    value={cost.monthlyCost}
                    displayType="text"
                    thousandSeparator=" "
                    renderText={val => getText('default.currency', val)}
                  />
                </td>
              </tr>
              <tr key="months">
                <td style={tdStyle}>
                  {getText('payApply.priceSignageCost.months')}
                </td>
                <td style={{ ...tdStyle, textAlign: 'right' }}>
                  {`${cost.months} ${getText('default.abbreviations.month')}`}
                </td>
              </tr>
              <tr key="interest">
                <td style={tdStyle}>
                  {getText('payApply.priceSignageCost.interest')}
                </td>
                <td style={{ ...tdStyle, textAlign: 'right' }}>
                  {`${cost.interest} %`}
                </td>
              </tr>
              <tr key="effectiveInterest">
                <td style={tdStyle}>
                  {getText('payApply.priceSignageCost.effectiveInterest')}
                </td>
                <td style={{ ...tdStyle, textAlign: 'right' }}>
                  {`${cost.effectiveInterest} %`}
                </td>
              </tr>
              <tr key="agreementFee">
                <td style={tdStyle}>
                  {getText('payApply.priceSignageCost.agreementFee')}
                </td>
                <td style={{ ...tdStyle, textAlign: 'right' }}>
                  <NumberFormat
                    value={cost.agreementFee}
                    displayType="text"
                    thousandSeparator=" "
                    renderText={val => getText('default.currency', val)}
                  />
                </td>
              </tr>
              <tr key="administrationFee">
                <td style={tdStyle}>
                  {getText('payApply.priceSignageCost.administrationFee')}
                </td>
                <td style={{ ...tdStyle, textAlign: 'right' }}>
                  <NumberFormat
                    value={cost.administrationFee}
                    displayType="text"
                    thousandSeparator=" "
                    renderText={val => getText('default.currency', val)}
                  />
                </td>
              </tr>
              <tr key="totalCost">
                <td style={tdStyle}>
                  {getText('payApply.priceSignageCost.totalCost')}
                </td>
                <td style={{ ...tdStyle, textAlign: 'right' }}>
                  <NumberFormat
                    value={cost.totalCost}
                    displayType="text"
                    thousandSeparator=" "
                    renderText={val => getText('default.currency', val)}
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      )}
    </React.Fragment>
  )
}

CreditInfo.propTypes = {
  cost: PropTypes.object,
  limit: PropTypes.number,
  onSendMail: PropTypes.func.isRequired,
}

CreditInfo.defaultProps = {
  limit: null,
  cost: undefined,
}

export default CreditInfo
